'use strict';exports.__esModule = true;var commodities = exports.commodities = [
'renovation',
'window_bars',
'shelter',
'master_bedroom',
'air_conditioner',
'warehouse',
'garbage_chute',
'gym',
'accessible',
'stroller_room',
'furnished',
'roommates',
'pool'];


var parking = exports.parking = function parking(translate) {return [
  {
    label: '' + translate('options', 'none'),
    value: 'none' },

  {
    label: '1',
    value: '1' },

  {
    label: '2',
    value: '2' },

  {
    label: '3',
    value: '3' },

  {
    label: '' + translate('options', 'double'),
    value: 'double' }];};




var balcony = exports.balcony = function balcony(translate) {return [
  {
    label: '' + translate('options', 'none'),
    value: '0' },

  {
    label: '1',
    value: '1' },

  {
    label: '2',
    value: '2' },

  {
    label: '3',
    value: '3' },

  {
    label: '4+',
    value: '4' }];};



var bathrooms = exports.bathrooms = [
{
  label: '1',
  value: '1' },

{
  label: '2',
  value: '2' },

{
  label: '3',
  value: '3' },

{
  label: '4',
  value: '4' },

{
  label: '5+',
  value: '5' }];



var commoditiesOptions = exports.commoditiesOptions = function commoditiesOptions(translate) {return [
  {
    id: 'renovation',
    label: '' + translate('commoditiesOptions', 'renovation') },

  {
    id: 'air_conditioner',
    label: '' + translate('commoditiesOptions', 'air_conditioner') },

  {
    id: 'window_bars',
    label: '' + translate('commoditiesOptions', 'window_bars') },

  {
    id: 'master_bedroom',
    label: '' + translate('commoditiesOptions', 'master_bedroom') },

  {
    id: 'shelter',
    label: '' + translate('commoditiesOptions', 'shelter') },

  {
    id: 'warehouse',
    label: '' + translate('commoditiesOptions', 'warehouse') },

  {
    id: 'furnished',
    label: '' + translate('commoditiesOptions', 'furnished') },

  {
    id: 'roommates',
    label: '' + translate('commoditiesOptions', 'roommates') },

  {
    id: 'pool',
    label: '' + translate('commoditiesOptions', 'pool') }];};



var additionsOptions = exports.additionsOptions = function additionsOptions(translate) {return [
  {
    id: 'garbage_chute',
    label: '' + translate('additionalsOptions', 'garbage_chute') },

  {
    id: 'gym',
    label: '' + translate('additionalsOptions', 'gym') },

  {
    id: 'accessible',
    label: '' + translate('additionalsOptions', 'accessible') },

  {
    id: 'stroller_room',
    label: '' + translate('additionalsOptions', 'stroller_room')

    // { TODO: in the future will be elevator in cottage
    //   id: 'elevator',
    //   label: `${translate('additionalsOptions', 'elevator')}`
    // }
  }];};

var elevators = exports.elevators = function elevators(translate) {return [
  {
    label: '' + translate('options', 'none'),
    value: '0' },

  {
    label: '1',
    value: '1' },

  {
    label: '2',
    value: '2' },

  {
    label: '3',
    value: '3' },

  {
    label: '4+',
    value: '4' }];};



var inputStyleTheme = exports.inputStyleTheme = {
  container: 'location-input__container',
  containerOpen: 'location-input__container--open',
  input: 'location-input__input',
  suggestionsContainer: 'location-input__suggestions-container',
  suggestionsList: 'location-input__suggestions-list',
  suggestion: 'location-input__suggestion',
  suggestionFocused: 'location-input__focused',
  sectionContainer: 'location-input__section-container',
  sectionTitle: 'location-input__section-title' };


var aboutPropertyBlockFields = exports.aboutPropertyBlockFields = [
'light_direction',
'groundFloor',
'floor',
'parking',
'balconies',
'balconies_area',
'bathrooms',
'toilets'];


var priceBlockFields = exports.priceBlockFields = ['entry_date', 'search_option', 'currency'];

/* Please, don't change the order of the list - the sequence for the scroll fields will be broken */
var publishPropertyRequiredFields = exports.publishPropertyRequiredFields = [
'address',
'rooms',
'area',
'floor',
'balconies_area',
'construction_year',
'images',
'price',
'contacts'];


var getCustomerTypes = exports.getCustomerTypes = function getCustomerTypes(translate) {return [
  { label: translate('regular'), value: 'regular' },
  { label: translate('agent'), value: 'agent' }];};


var currencies = exports.currencies = {
  ILS: 'ILS',
  USD: 'USD',
  EUR: 'EUR' };


var currenciesOptions = exports.currenciesOptions = [
{ label: '₪', value: currencies.ILS },
{ label: '$', value: currencies.USD },
{ label: '€', value: currencies.EUR }];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/PublishPropertyFormConstants.js
// module id = 128
// module chunks = 0